import { Grid, Typography, Box } from "@material-ui/core";
import useCustomState from "../hooks/State";
import {
  WHITE,
  GREEN_PRIMRY,
  countersPageSize,
  BLUE_COLOR,
  ORANGE_COLOR,
  ERROR_COLOR,
  BLUE_PRIMARY,
} from "../utils/const";
import Loading from "../components/loading";
import { useSelector } from "react-redux";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { convertNumbers } from "../utils/ConvertNumbers";
import { useMountAPI } from "../hooks/APICall";
import ChartArea from "../components/homeChartArea";
import CountersPerCategoryChart from "../components/countersPerCategoryChart";
import { useHistory } from "react-router";
import Call from "../service/API";
import CountersPerTypeChart from "../components/countersPerTypeChart";
import { Link } from "react-router-dom";
import Paginator from "../components/paginator";
import InfoIcon from "@material-ui/icons/Info";
import { useEffect } from "react";
import CountersPerTypeSelledChart from "../components/countersPerTypeSelledChart";

const CounterReports = (props) => {
  const totalStatistics = useCustomState({});
  const totalStatisticsIsLoading = useCustomState(true);

  const categories = useSelector((state) => state.categories);
  const statistics = useSelector((state) => state.statistics);
  const counterTypes = useSelector((state) => state.counterTypes);

  const typesIsLoading = useCustomState(true);
  const types = useCustomState([]);
  const allItems = useCustomState(0); // for pagination
  const selectedPage = useCustomState(1); // for pagination
  const countersIsLoading = useCustomState(true);
  const counters = useCustomState([]);
  const categoryCounters = useCustomState({});

  const history = useHistory();

  const totalStatisticsUtils = {
    isLoading: totalStatisticsIsLoading,
    totalStatistics: totalStatistics,
    history: history,
  };

  const typesUtils = {
    isLoading: typesIsLoading,
    types: types,
    page: 1,
    count: 10000,
    typeName: "",
    typeDate: "",
    history: history,
  };

  const countersUtils = {
    page: selectedPage.value, // for pagination
    count: countersPageSize, // for pagination
    isLoading: countersIsLoading,
    history: history,
    allItems: allItems, // for pagination
    counters: counters,
  };

  useMountAPI(fetchTypes, typesUtils);
  useMountAPI(fetchCounters, countersUtils);
  useMountAPI(fetchStatistics, totalStatisticsUtils);

  // for pagination
  const selectedPageChanged = (newPage) => {
    if (newPage !== selectedPage.value) {
      selectedPage.handleChange(newPage);
      countersUtils.page = newPage;
      countersIsLoading.handleChange(true);
      fetchCounters(countersUtils);
    }
  };

  const renderCountersStatisticsTable = () => {
    if (totalStatisticsIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer
          component={Paper}
          style={{
            width: "400px",
            maxWidth: "400px",
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableBody>
              <TableRow>
                <TableCell>تعداد کل کنتورها</TableCell>
                <TableCell>
                  {convertNumbers(totalStatistics.value.counters)}
                </TableCell>
              </TableRow>
              {totalStatistics.value.categories.map((category, idx) => {
                return (
                  <TableRow key={idx}>
                    <TableCell>{"تعداد کنتور " + category.name}</TableCell>
                    <TableCell>{convertNumbers(category.counters)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderCountersStatistics = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "48px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              maxWidth: "400px",
              width: "400px",
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>آمار کلی</Typography>
          </Box>
          {renderCountersStatisticsTable()}
        </Grid>
      </>
    );
  };

  const renderSelledCharts = () => {
    return <CountersPerTypeSelledChart />;
  };

  const renderselledCounterPerTypeStatistics = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "16px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Typography style={{ fontWeight: "bold" }}>
            آمار فروش کنتورها بر حسب نوع
          </Typography>
          {renderSelledCharts()}
        </Grid>
      </>
    );
  };

  const renderTableCountersPerCategory = () => {
    if (totalStatisticsIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer component={Paper}>
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align={"center"}>#</TableCell>
                <TableCell align={"center"}>دسته</TableCell>
                <TableCell align={"center"}>تعداد کنتور</TableCell>
                <TableCell align={"center"}>تعداد کنتور (%)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {totalStatistics.value.categories.map((category, idx) => {
                return (
                  <TableRow key={idx}>
                    <TableCell align={"center"}>
                      {convertNumbers(idx + 1)}
                    </TableCell>
                    <TableCell align={"center"}>{category.name}</TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(category.counters)}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(
                        (
                          (category.counters / totalStatistics.value.counters) *
                          100.0
                        ).toFixed(2) + "%"
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderChartCountersPerCategory = () => {
    if (totalStatisticsIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      const categoriesStatistics = {};
      totalStatistics.value.categories.map((category) => {
        categoriesStatistics[category.name] = category.counters;
      });
      return <CountersPerCategoryChart categories={categoriesStatistics} />;
    }
  };

  const renderCountersPerCategoryStatistics = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "16px",
            paddingBottom: "16px",
            marginBottom: "16px",
            // borderBottom: "1px solid #333333",
          }}
        >
          <Typography style={{ fontWeight: "bold" }}>
            آمار تعداد کنتورها بر حسب دسته
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={5}
          style={{
            borderBottom: "1px solid #333333",
            height: "360px",
            overflow: "scroll",
          }}
        >
          {renderTableCountersPerCategory()}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={7}
          style={{
            borderBottom: "1px solid #333333",
            height: "360px",
            overflow: "scroll",
          }}
        >
          {renderChartCountersPerCategory()}
        </Grid>
      </>
    );
  };

  const renderChartCountersPerType = () => {
    if (typesIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      return <CountersPerTypeChart types={types.value} />;
    }
  };

  const renderTableCountersPerType = () => {
    if (typesIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer component={Paper}>
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align={"center"}>#</TableCell>
                <TableCell align={"center"}>نوع</TableCell>
                <TableCell align={"center"}>تعداد کنتور</TableCell>
                <TableCell align={"center"}>تعداد کنتور (%)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {types.value.map((type, idx) => {
                const percent = (
                  (type.counters / statistics.counters) *
                  100.0
                ).toFixed(2);
                return (
                  <TableRow key={idx}>
                    <TableCell align={"center"}>
                      {convertNumbers(idx + 1)}
                    </TableCell>
                    <TableCell align={"center"}>{type.name}</TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(type.counters)}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(percent + "%")}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderCountersPerTypeStatistics = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "16px",
            paddingBottom: "16px",
            marginBottom: "16px",
            // borderBottom: "1px solid #333333",
          }}
        >
          <Typography style={{ fontWeight: "bold" }}>
            آمار تعداد کنتورها بر حسب نوع
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={7}
          style={{
            borderBottom: "1px solid #333333",
            height: "380px",
            overflow: "scroll",
          }}
        >
          {renderChartCountersPerType()}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={5}
          style={{
            borderBottom: "1px solid #333333",
            height: "380px",
            overflow: "scroll",
          }}
        >
          {renderTableCountersPerType()}
        </Grid>
      </>
    );
  };

  const renderCounterDetailsTable = () => {
    if (countersIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "260px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer
          component={Paper}
          style={{
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align={"center"}>#</TableCell>
                <TableCell align={"center"}>نام کنتور</TableCell>
                <TableCell align={"center"}>شماره سریال</TableCell>
                <TableCell align={"center"}>دسته</TableCell>
                <TableCell align={"center"}>نوع</TableCell>
                <TableCell align={"center"}>پروژه</TableCell>
                <TableCell align={"center"}>وضعیت تایید</TableCell>
                <TableCell align={"center"}>وضعیت فعال سازی</TableCell>
                <TableCell align={"center"}>جزئیات</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {counters.value.map((counter, idx) => {
                const categoryStyle = {
                  color: "#fff",
                  backgroundColor: "green",
                  fontSize: "12px",
                  borderRadius: "4px",
                  paddingRight: "6px",
                  paddingLeft: "6px",
                  marginRight: "8px",
                };
                const confirmStyle = {
                  color: "#fff",
                  backgroundColor: "green",
                  fontSize: "12px",
                  borderRadius: "4px",
                  paddingRight: "6px",
                  paddingLeft: "6px",
                  marginRight: "8px",
                };
                const activeStyle = {
                  color: "#fff",
                  backgroundColor: "green",
                  fontSize: "12px",
                  borderRadius: "4px",
                  paddingRight: "6px",
                  paddingLeft: "6px",
                  marginRight: "8px",
                };
                if (counter.category.includes("آب")) {
                  categoryStyle.backgroundColor = BLUE_COLOR;
                } else if (counter.category.includes("برق")) {
                  categoryStyle.backgroundColor = ERROR_COLOR;
                } else {
                  categoryStyle.backgroundColor = ORANGE_COLOR;
                }
                let confirmText = "تایید نشده";
                let activeText = "غیر فعال";
                if (counter.validation) {
                  confirmStyle.backgroundColor = GREEN_PRIMRY;
                  confirmText = "تایید شده";
                } else {
                  confirmStyle.backgroundColor = ERROR_COLOR;
                  confirmText = "تایید نشده";
                }
                if (counter.activation) {
                  activeStyle.backgroundColor = GREEN_PRIMRY;
                  activeText = "فعال";
                } else {
                  activeStyle.backgroundColor = ERROR_COLOR;
                  activeText = "غیرفعال";
                }
                const category = (
                  <span style={categoryStyle}>
                    {convertNumbers(counter.category)}
                  </span>
                );
                const validation = (
                  <span style={confirmStyle}>{confirmText}</span>
                );
                const activation = (
                  <span style={activeStyle}>{activeText}</span>
                );
                return (
                  <TableRow>
                    <TableCell align={"center"}>
                      {convertNumbers(
                        (selectedPage.value - 1) * countersPageSize + idx + 1
                      )}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(counter.name)}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(counter.serial)}
                    </TableCell>
                    <TableCell align={"center"}>{category}</TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(counter.type)}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(counter.project)}
                    </TableCell>
                    <TableCell align={"center"}>{validation}</TableCell>
                    <TableCell align={"center"}>{activation}</TableCell>
                    <TableCell align={"center"}>
                      <Link to={"/admin/counter/" + counter.serial}>
                        <InfoIcon
                          style={{
                            color: BLUE_PRIMARY,
                            fontSize: "24px",
                            cursor: "pointer",
                          }}
                        />
                      </Link>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderPaginator = () => {
    {
      /* 
            begin: for pagination
          */
    }
    return (
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Grid container>
          <Paginator
            selectedPage={selectedPage.value}
            items={allItems.value}
            pageSize={countersPageSize}
            selectedPageChanged={selectedPageChanged}
          />
        </Grid>
      </Grid>
    );
    {
      /* end: for pagination */
    }
  };

  const renderCountersDetails = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "16px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>
              جزئیات آمار کنتورها
            </Typography>
          </Box>
          {renderCounterDetailsTable()}
          {renderPaginator()}
        </Grid>
      </>
    );
  };

  return (
    <Grid
      container
      style={{
        marginTop: "64px",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingRight: "8px",
        paddingLeft: "8px",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          backgroundColor: WHITE,
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "24px",
          paddingBottom: "24px",
          borderRadius: "8px",
          position: "relative",
        }}
      >
        <Box
          style={{
            maxWidth: "250px",
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: "-60px",
            paddingRight: "36px",
            paddingLeft: "36px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "12px",
            backgroundColor: GREEN_PRIMRY,
            color: WHITE,
            cursor: "pointer",
          }}
          textAlign={"center"}
        >
          <Typography style={{ fontWeight: "bold" }}>گزارش کنتورها</Typography>
        </Box>
        <Grid container>
          {renderCountersStatistics()}
          {renderselledCounterPerTypeStatistics()}
          {renderCountersPerCategoryStatistics()}
          {renderCountersPerTypeStatistics()}
          {renderCountersDetails()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CounterReports;

const processTotalStatistics = (pureStatistics) => {
  return pureStatistics;
};

const fetchTotalStatistics = (utils) => {
  const isLoading = utils.isLoading;
  isLoading.handleChange(false);
};

const processTypes = (types) => {
  const results = [];
  types.map((type) => {
    const data = {
      id: type.water_meter_type_id,
      name: type.water_meter_type_name,
      counters: type.All_counter_with_this_type,
    };
    results.push(data);
  });
  return results;
};

const fetchTypes = (utils) => {
  const isLoading = utils.isLoading;
  const types = utils.types;
  const page = utils.page;
  const count = utils.count;
  const typeName = utils.typeName;
  const typeDate = utils.typeDate;
  const history = utils.history;

  const data = {
    page: page,
    count: count,
    water_meter_type_name: typeName,
    water_meter_type_create_date: typeDate,
  };

  Call("POST", "WaterMeterTypes/admin/getAll", data)
    .then((response) => {
      // console.log("counterTypes test", response);
      if (response.data.code == 200) {
        types.handleChange(processTypes(response.data.data.results));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code == 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};

const processCounters = (counters) => {
  const results = [];
  let data;
  counters.map((counter) => {
    data = {
      name: counter.water_meter_name,
      serial: counter.water_meter_serial,
      type: counter.water_meter_type_info.water_meter_type_name,
      category: counter.water_meter_tag_info.water_meter_tag_name,
      project: counter.water_meter_project_info.project_name,
      validation: counter.water_meter_validation,
      activation: counter.water_meter_activation,
    };
    results.push(data);
  });
  return results;
};

const fetchCounters = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const isLoading = utils.isLoading;
  const history = utils.history;
  const allItems = utils.allItems; // for pagination
  const counters = utils.counters;

  const data = {
    page: page,
    count: count,
    user_id: null,
    project_id: null,
  };

  Call("POST", "watermeters/admin/getAll", data)
    .then((response) => {
      // console.log("counters", response);
      if (response.data.code == 200) {
        const cs = response.data.data;
        /* begin: for pagination */
        if (cs && cs.length !== 0) {
          allItems.handleChange(cs[0].all_water_meters);
        }
        /* end: for pagination */
        counters.handleChange(processCounters(cs));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code == 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};

const processStatistics = (statistics) => {
  const dataKeys = Object.keys(statistics);
  const processedStatistics = { counters: 0, categories: [] };
  dataKeys.map((key) => {
    if (key === "all_water_meters_count") {
      processedStatistics.counters = statistics[key];
    } else {
      const data = {
        name: key,
        counters: statistics[key],
      };
      processedStatistics.categories.push(data);
    }
  });
  // console.log("processed statistics: ", processedStatistics);
  return processedStatistics;
};

const fetchStatistics = (utils) => {
  const isLoading = utils.isLoading;
  const totalStatistics = utils.totalStatistics;
  const history = utils.history;

  Call("POST", "WaterMeterTags/admin/total/statistcs", null)
    .then((response) => {
      // console.log("total statistics: ", response);
      if (response.data.code === 200) {
        totalStatistics.handleChange(processStatistics(response.data.data));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      // console.log(error);
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code === 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};
